export default {
  message: {
    noData: "Chưa có dữ liệu",
  },
  header: {
    home: "Bongda",
    anchor: "Live tất cả",
    schedule: "Lịch đấu",
    news: "Tin tức",
    subscribe: "Theo dõi",
    anchor_recruitment: "Tuyển",
    download: "Tải APP",
    apply_anchor: "Ứng tuyển người dẫn chương trình",
    login: "Đăng nhập",
    register: "Đăng ký",
    personal_center: "Trung tâm cá nhân",
    logout: "Đăng xuất",
    主播教程: "Hướng dẫn",
  },
  footer: {
    pro_anchor_exclusive:
      "Người dẫn chương trình chuyên nghiệp · Giải đấu độc quyền",
    global_events: "Sự kiện toàn cầu",
    hd_live: "Phát sóng HD",
    pro_anchor: "Người dẫn chương trình chuyên nghiệp",
    massive_data: "Dữ liệu khổng lồ",
    user_agreement: "Thỏa thuận người dùng",
    privacy_policy: "Chính sách bảo mật",
    disclaimer: "Tuyên bố miễn trừ trách nhiệm",
    permission_details: "Chi tiết quyền",
    ios_download: "Tải IOS",
    android_download: "Tải Android",
    qr_code: "Mã QR",
  },
  downloadTip: {
    online_service: "Dịch vụ trực tuyến",
    download: "Tải xuống",
    qr_code: "Mã QR",
    download_app: "Tải APP",
    more_live: "Nhiều trận đấu trực tiếp hơn",
    cooperation: "Hợp tác",
    no_content: "Chưa có nội dung liên quan, vui lòng chờ đợi!",
  },
  findPassword: {
    title: "Lấy lại mật khẩu",
    input_phone: "Vui lòng nhập số điện thoại",
    input_code: "Vui lòng nhập mã xác minh",
    input_password: "Vui lòng nhập mật khẩu",
    code_empty: "Mã xác minh không được để trống",
    get_code: "Lấy mã",
    resend: "Gửi lại ({second})",
    get_code_success: "Lấy mã xác minh thành công",
    phone_warn: "Vui lòng điền số điện thoại đúng định dạng",
    pass_warn: "Mật khẩu phải là 6-20 ký tự chữ và số!",
    find_now: "Lấy lại ngay",
    success: "Đổi mật khẩu thành công, vui lòng đăng nhập lại!",
  },
  register: {
    title: "Đăng ký",
    input_phone: "Vui lòng nhập số điện thoại",
    input_code: "Vui lòng nhập mã xác minh",
    input_password: "Vui lòng nhập mật khẩu 6-20 ký tự chữ và số",
    code_warn: "Vui lòng nhập mã xác minh đúng định dạng",
    pass_warn: "Vui lòng nhập mật khẩu 6-20 ký tự chữ và số",
    go_login: "Đi đến đăng nhập",
    register_and_login: "Đăng ký và đăng nhập",
    get_code: "Lấy mã",
    resend: "Gửi lại ({second})",
    get_code_success: "Mã xác minh đã gửi thành công, vui lòng kiểm tra",
    phone_warn: "Vui lòng điền số điện thoại đúng định dạng",
    login_success: "Đăng nhập thành công",
  },
  mainTain: {
    img_alt: "Hình ảnh",
    system_maintain: "Hệ thống đang bảo trì...",
    maintain_words:
      "Để phục vụ bạn tốt hơn, trang web đang được nâng cấp và bảo trì, xin lỗi vì sự bất tiện này",
  },
  login: {
    title: "Đăng nhập",
    input_phone: "Vui lòng nhập số điện thoại",
    input_password: "Vui lòng nhập mật khẩu",
    register_now: "Đăng ký ngay",
    forget_password: "Quên mật khẩu",
    login_btn: "Đăng nhập",
    phone_warn: "Vui lòng điền số điện thoại đúng định dạng",
    pass_warn: "Mật khẩu phải là 6-20 ký tự chữ và số!",
    phone_empty: "Vui lòng điền số điện thoại",
    pass_empty: "Vui lòng điền mật khẩu",
    login_success: "Đăng nhập thành công",
    pass_error: "Mật khẩu sai!",
  },
  livingRank: {
    gold_anchor: "Người dẫn chương trình vàng",
    anchor_recommend: "Gợi ý người dẫn chương trình",
    change_batch: "Đổi lô",
    subscribe: "Đăng ký",
    subscribed: "Đã đăng ký",
    hot_recommend: "Gợi ý nổi bật",
  },
  introduceLive: {
    live_recommend: "Gợi ý phát sóng trực tiếp",
    recommend: "Gợi ý",
    tab_all: "Tất cả",
    tab_live: "Đang trực tiếp",
    tab_hot: "Nổi bật",
    tab_today: "Hôm nay",
    tab_tomorrow: "Ngày mai",
    watch_now: "Xem ngay",
    status_live: "Đang trực tiếp",
    status_upcoming: "Sắp diễn ra",
    status_ended: "Đã kết thúc",
    足球: "Bóng đá",
    篮球: "Bóng rổ",
    电竞: "Thể thao điện tử",
    网球: "Quần vợt",
    排球: "Bóng chuyền",
    乒乓球: "Bóng bàn",
    羽毛球: "Cầu lông",
    板球: "Cricket",
    搏击: "Võ thuật",
    其他: "Khác",
    icon_alt: "Biểu tượng",
  },
  tipBox: {
    success: "Thao tác thành công",
    login_success: "Đăng nhập thành công",
  },
  video: {
    loading: "Đang tải...",
    download_app: "Tải APP",
    more_live: "Nhiều trận đấu trực tiếp hơn",
    more_video: "Nhiều video trận đấu hơn",
    link_failed: "Liên kết thất bại, vui lòng tải lại",
    reload: "Tải lại",
    danmu: "Đạn màn hình",
    enter_live: "Vào phòng phát sóng",
    drag_tip: "Giữ video để kéo",
    click_pause: "Nhấp để tạm dừng",
    click_play: "Nhấp để phát",
    click_mute: "Nhấp để tắt tiếng",
    cancel_mute: "Bỏ tắt tiếng",
    click_fullscreen: "Nhấp để toàn màn hình",
    exit_fullscreen: "Thoát toàn màn hình",
    load_error: "Lỗi tải",
  },
  home: {
    announcement: "Thông báo",
    match_recommend: "Gợi ý giải đấu",
    icon_alt: "Biểu tượng",
    living: "Đang phát sóng",
    book_now: "Đặt ngay",
    ended: "Đã kết thúc",
    match_ended: "Trận đấu đã kết thúc!",
    coming_soon: "Sắp ra mắt!",
    not_started: "Chưa bắt đầu",
    delayed: "Đã hoãn",
    deleted: "Đã xóa",
  },
  myLiving: {
    my_live: "Phát sóng của tôi",
    subscribe: "Đăng ký",
    exit_live: "Thoát phát sóng",
    tips: "Lời nhắc nhở",
    obs_tip:
      "Sử dụng OBS hoặc phần mềm phát sóng trực tiếp bên thứ ba khác để phát sóng, nhấp vào bắt đầu phát sóng sau khi đẩy thành công",
    push_url: "Địa chỉ đẩy",
    stream_name: "Tên luồng",
    copy: "Nhấp để sao chép",
    start_live: "Bắt đầu phát sóng",
    live_notice: "Thông báo phát sóng",
    contact_us: "Liên hệ chúng tôi",
    copy_success: "Sao chép thành công, hãy liên hệ người dẫn chương trình!",
    copy_address_success: "Sao chép địa chỉ thành công",
    edit_notice_tip:
      "Chỉ có thể chỉnh sửa thông tin phát sóng sau khi bắt đầu phát sóng",
  },
  advisory: {
    hot_recommend: "Gợi ý nổi bật",
    related: "Bài viết liên quan",
    recommend: "Tin tức gợi ý",
    more: "Thêm",
    loading: "Đang tải",
    scroll_load_more: "Cuộn xuống để tải thêm",
    no_more: "Bạn đã xem đến cuối~",
    关注: "Theo dõi",
    取消关注: "Hủy theo dõi",
    已经关注: "Đã theo dõi",
    作者: "Tác giả",
    发布时间: "Ngày phát hành",
    阅读次数: "Lượt đọc",
    当前位置: "Vị trí hiện tại",
    首页: "Trang chủ",
    新闻资讯: "Tin tức",
    粉丝: "Người hâm mộ",
    文章数: "Số bài viết",
    收藏: "Sưu tầm",
    已收藏: "Đã sưu tầm",
    分享: "Chia sẻ",
    上一篇: "Bài trước",
    下一篇: "Bài sau",
    发表评论: "Bình luận",
    热门评论: "Bình luận nổi bật",
    我有话说: "Tôi có lời muốn nói...",
    赞: "Thích",
    评论: "Bình luận",
    确定提交: "Xác nhận gửi",
    查看更多评论: "Xem thêm bình luận",
    条: "bài",
    拼命加载中: "Đang tải dữ liệu...",
    暂无评论: "Chưa có bình luận",
    authorDes:
      "Người sống nghiêm túc, cố gắng làm hết sức mình, phó mặc cho trời!",
  },
  competition: {
    nav_0: "Bóng đá",
    nav_1: "Bóng rổ",
    // nav_2: "Đặt chỗ của tôi",
    sub_nav_0: "Tất cả",
    sub_nav_1: "Đang diễn ra",
    sub_nav_2: "Lịch thi đấu",
    sub_nav_3: "Kết quả",
    all_matches: "Tất cả giải đấu",
    kill: "Tiêu diệt",
    economy: "Kinh tế",
    tower: "Phá tháp",
    dragon: "Rồng nhỏ",
    odds: "Chỉ số",
    analysis: "Phân tích",
    ended: "Đã kết thúc",
    not_started: "Chưa bắt đầu",
    delayed: "Đã hoãn",
    deleted: "Đã xóa",
    match_num: "Trận {num}",
    week: "Tuần",
    today: "Hôm nay",
    loading: "Đang tải thêm dữ liệu...",
    no_more_data: "Không còn dữ liệu",
    今天: "Hôm nay",
    今日: "Hôm nay",
    周日: "Chủ nhật",
    周一: "Thứ hai",
    周二: "Thứ ba",
    周三: "Thứ tư",
    周四: "Thứ năm",
    周五: "Thứ sáu",
    周六: "Thứ bảy",
    完场: "Đã kết thúc",
    比赛异常: "Trận đấu đã kết thúc!",
    未开赛: "Chưa bắt đầu",
    第一节: "Hiệp 1",
    第一节完: "Hiệp 1 đã kết thúc",
    第二节: "Hiệp 2",
    第二节完: "Hiệp 2 đã kết thúc",
    第三节: "Hiệp 3",
    第三节完: "Hiệp 3 đã kết thúc",
    第四节: "Hiệp 4",
    加时: "Thêm thời gian",
    中断: "Ngừng",
    延期: "Hoãn",
    腰斩: "Ngừng",
    进行中: "Đang diễn ra",
    取消: "Đã hủy",
    待定: "Kết quả",
    上半场: "Nửa hiệp đầu",
    中场: "Nửa hiệp giữa",
    下半场: "Nửa hiệp sau",
    加时赛: "Thêm thời gian",
    点球决战: "Điểm thi",
    延迟: "Hoãn",
    没有更多数据了: "Không còn dữ liệu",
    更多数据正在加载中: "Đang tải thêm dữ liệu...",
  },
  download: {
    scan_tip: "Quét mã để tải APP Phát sóng trực tiếp",
    ios_download: "Tải IOS",
    android_download: "Tải Android",
    android_download2: "Tải Android",
    ios_guide: "Xem hướng dẫn cài đặt ios",
    global_matches: "Giải đấu toàn cầu",
    hd_live: "Phát sóng HD",
    pro_live: "Phát sóng chuyên nghiệp",
    mass_data: "Dữ liệu khổng lồ",
  },
  giftItem: {
    send_gift: "Gửi {gift}",
  },
  live: {
    recommend: "Gợi ý",
    推荐: "Gợi ý",
    足球: "Bóng đá",
    篮球: "Bóng rổ",
    电竞: "Thể thao điện tử",
    网球: "Quần vợt",
    排球: "Bóng chuyền",
    乒乓球: "Bóng bàn",
    羽毛球: "Cầu lông",
    板球: "Cricket",
    搏击: "Võ thuật",
    全部: "Tất cả",
    其他: "Khác",
    icon_alt: "Biểu tượng",
    loading: "Đang tải...",
    no_more: "Không còn dữ liệu",
    load_more: "Xem thêm",
  },
  liveChat: {
    enter_room: "Vào phòng chat",
    anchor_offline:
      "Người dẫn chương trình đã tắt phát sóng, không thể gửi nội dung chat",
    room_closed: "Phòng chat đã đóng",
    input_tip: "Vui lòng nhập nội dung chat không quá 30 ký tự...",
    please: "Vui lòng",
    login: "Đăng nhập",
    send: "Gửi",
    new_msg: "Có {num} tin nhắn mới",
    welcome: "Chào mừng",
    iknow: "Tôi biết rồi",
    muted_tip: "Bạn đã bị cấm chat, vui lòng liên hệ quản trị viên!",
    force_offline:
      "Bạn đã bị buộc tắt phát sóng, vui lòng liên hệ dịch vụ khách hàng!",
    muted: "Đã bị cấm chat",
    cleared: "Thông tin chat đã được xóa",
    room_closed_try: "Phòng chat đã đóng, vui lòng thử lại sau!",
    loading: "Đang tải dữ liệu chat, vui lòng đợi!",
    input_empty: "Vui lòng nhập nội dung chat!",
    room_opened: "Phòng chat đã mở",
  },
  liveDetails: {
    resting: "Người dẫn chương trình đang nghỉ…",
    sports_live: "Phát sóng trực tiếp",
    share: "Chia sẻ",
    share_tip: "Gọi bạn bè đến xem cùng",
    copy: "Sao chép",
    mobile_watch: "Xem trên điện thoại",
    download_app_anytime: "Tải APP mọi lúc mọi nơi",
    free_watch: "Xem phát sóng trực tiếp giải đấu miễn phí",
    qr_alt: "Mã QR",
    people: "người",
    subscribe: "Đăng ký",
    subscribed: "Đã đăng ký",
    anchor_offline: "Người dẫn chương trình đã tắt phát sóng",
    recommend_live: "Gợi ý phát sóng cho bạn",
    subscribe_tip: "Đăng ký người dẫn chương trình để nhận thông báo phát sóng",
    icon_alt: "Biểu tượng",
    live_notice: "Thông báo phát sóng",
    welcome: "Chào mừng đến phòng phát sóng của {name}",
    contact_us: "Liên hệ chúng tôi",
    qq_wechat: "qq/wechat",
    push_order: "Người dẫn chương trình đẩy đơn",
    push_order_list: "Danh sách đẩy đơn",
    follow: "người theo đơn",
    oppose: "người mua ngược",
    combo: "Combo",
    give: "Tặng",
    match_waiting_title: "Trận đấu sẽ sớm bắt đầu.",
    match_waiting_tip:
      "Từ 15 phút trước giờ đấu, hệ thống sẽ kiểm tra người dẫn chương trình mỗi 3 phút và tự động chuyển phòng khi có dữ liệu.",
    match_waiting_side_title: "Đang chờ mở sóng",
    match_room_notice:
      "Hiện chưa có người dẫn chương trình cho trận đấu này. Hệ thống sẽ tự động kiểm tra trước giờ đấu.",
    assigned_match_room_notice:
      "Trận đấu này đã được gán người dẫn chương trình. Phòng sẽ hiển thị đếm ngược và tự động kiểm tra cho đến khi bắt đầu phát sóng.",
    countdown_days: "Ngày",
    countdown_hours: "Giờ",
    countdown_minutes: "Phút",
    countdown_seconds: "Giây",
  },
  liveSettingDialog: {
    title: "Cài đặt phát sóng",
    live_title: "Tiêu đề phát sóng",
    live_category: "Phân loại phát sóng",
    service_select: "Chọn dịch vụ khách hàng",
    cover_upload: "Tải lên ảnh bìa",
    cover_tip:
      "Kích thước ảnh bìa đề xuất là 2MB, không tải lên ảnh bìa sẽ tự động chụp màn hình ngẫu nhiên làm ảnh bìa",
    live_notice: "Thông báo phát sóng",
    relate_title: "Phân tích dữ liệu giải đấu liên quan",
    just_live: "Chỉ phát sóng",
    relate_live: "Phát sóng với dữ liệu trận đấu",
    not_started: "Chưa bắt đầu",
    in_progress: "Đang thi đấu",
    team_logo: "Logo đội",
    contact_title: "Thông tin liên hệ",
    qq_number: "Số",
    qq_placeholder: "Vui lòng nhập số QQ liên hệ bạn muốn thêm",
    show_status: "Trạng thái hiển thị",
    hide_all: "Ẩn tất cả",
    show_all: "Hiển thị tất cả",
    show_copy: "Hiển thị nút sao chép",
    close: "Đóng",
  },
  personal: {
    account: "Tài khoản cá nhân",
    go_live: "Tôi muốn phát sóng",
    push_order: "Tôi muốn đẩy đơn",
    account_setting: "Cài đặt tài khoản",
    base_info: "Thông tin cơ bản",
    change_avatar: "Đổi avatar",
    change_password: "Đổi mật khẩu",
    change_skin: "Chuyển giao diện",
    my_social: "Mạng xã hội của tôi",
    my_follow: "Người tôi theo dõi",
    my_fans: "Người hâm mộ của tôi",
    my_room: "Phòng của tôi",
    my_live_room: "Phòng phát sóng của tôi",
    my_live_record: "Lịch sử phát sóng của tôi",
    diamond: "Kim cương",
    tip: "Gợi ý",
    switch_skin_tip: "Có chuyển sang giao diện {skin} không?",
    cancel: "Hủy",
    confirm: "Xác nhận",
    unmute_tip: "Xác nhận có bỏ cấm chat người dùng này không",
    green: "Xanh lá",
    orange: "Cam",
    save: "Lưu",
    upload_avatar: "Tải lên avatar",
    only_support: "(Chỉ hỗ trợ jpg, jpeg, png)",
    keep: "Lưu",
    follow: "Theo dõi",
    fans: "Người hâm mộ",
    subscription: "Đăng ký",
    cancel_follow: "Hủy theo dõi",
    subscribe: "Đăng ký",
    unsubscribe: "Hủy đăng ký",
    search: "Tìm kiếm",
    range_separator: "đến",
    start_time: "Ngày bắt đầu",
    end_time: "Ngày kết thúc",
    query_time: "Thời gian truy vấn",
    live_title: "Tiêu đề phát sóng",
    live_type: "Loại phát sóng",
    live_start: "Thời gian bắt đầu",
    live_end: "Thời gian kết thúc",
    live_people: "Số người trong phòng",
    live_diamond: "Kim cương",
    live: "Phát sóng thông thường",
    live_alt: "Phát sóng",
    start_my_live: "Nhấp để bắt đầu phát sóng của tôi",
    watch_my_live: "Nhấp để xem phát sóng của tôi",
    current_password: "Mật khẩu hiện tại",
    new_password: "Mật khẩu mới",
    confirm_password: "Xác nhận mật khẩu",
    please_input: "Vui lòng nhập",
    please_input_nickname: "Vui lòng nhập biệt danh",
    please_input_signature: "Vui lòng nhập chữ ký",
    please_input_birthday: "Vui lòng nhập ngày sinh",
    please_input_password: "Vui lòng nhập mật khẩu hiện tại",
    please_input_new_password: "Vui lòng nhập mật khẩu mới",
    please_input_confirm_password: "Vui lòng nhập xác nhận mật khẩu",
    please_input_avatar: "Vui lòng tải lên ảnh avatar cần đổi",
    please_input_sign: "Vui lòng nhập chữ ký",
    please_input_room: "Vui lòng nhập số phòng",
    please_input_query: "Vui lòng nhập nội dung truy vấn",
    nickname_empty: "Biệt danh không được để trống",
    gender_secret: "Bí mật",
    gender_male: "Nam",
    gender_female: "Nữ",
    match_info: "Thông tin trận đấu",
    match_time: "Thời gian trận đấu",
    stream_address: "Địa chỉ stream",
    nickname: "Biệt danh",
    gender: "Giới tính",
    signature: "Chữ ký",
    birthday: "Ngày sinh",
    save_success: "Lưu thành công",
    save_fail: "Lưu thất bại",
    update_success: "Cập nhật thành công",
    upload_success: "Tải lên avatar thành công",
    upload_fail: "Tải lên avatar thất bại, vui lòng tải lên lại",
    password_success: "Đổi mật khẩu thành công",
    password_fail: "Mật khẩu phải là 6-20 ký tự chữ và số!",
    password_not_match:
      "Mật khẩu mới và xác nhận mật khẩu không khớp, vui lòng nhập lại",
    empty: "Chưa có dữ liệu",
    muted: "Bị cấm chat",
    unmute: "Bỏ cấm",
    unmute_success: "Bỏ cấm thành công!",
    status: "Trạng thái",
    operation: "Thao tác",
    anchor_name: "Tên người dẫn chương trình",
    processed_user: "Người bị xử lý",
  },
  pushOrder: {
    list: "Danh sách đẩy đơn",
    add: "Thêm đẩy đơn",
    id: "ID đẩy",
    category: "Loại đẩy đơn",
    select_category: "Vui lòng chọn loại đẩy đơn",
    status: "Trạng thái",
    select_status: "Vui lòng chọn trạng thái đẩy đơn",
    desc: "Mô tả đẩy đơn",
    input_desc: "Vui lòng nhập mô tả đẩy đơn",
    buy: "Theo đơn",
    oppose: "Mua ngược",
    operate: "Thao tác",
    edit: "Chỉnh sửa",
    delete: "Xóa",
    confirm_delete: "Bạn có chắc chắn xóa dữ liệu này không?",
    reset: "Đặt lại",
    search: "Tìm kiếm",
    searching: "Đang tìm kiếm",
    submit: "Gửi ngay",
    submitting: "Đang gửi",
  },
  subscription: {
    living_now: "Đang phát sóng",
    not_live: "Chưa phát sóng",
    please_login: "Vui lòng đăng nhập trước!",
    login: "Đăng nhập",
    no_subscribe_live: "Chưa có phát sóng đăng ký, hãy đăng ký ngay!",
    no_subscribe_anchor:
      "Chưa có người dẫn chương trình đăng ký, hãy đăng ký ngay!",
  },
};



// WEBPACK FOOTER //
// ./src/lang/vi.js